import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatApiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/login", { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page" className="min-h-[80vh] flex items-center justify-center bg-slate-50 px-6 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white border border-slate-200 rounded-md p-10">
          <h1 className="font-display text-3xl font-semibold text-slate-900 tracking-tight">Choose a new password.</h1>
          <p className="mt-2 text-slate-600 text-sm">At least 8 characters.</p>
          {!token && <div className="mt-4 text-xs text-red-600">Missing reset token in link.</div>}
          <form onSubmit={submit} className="mt-6 space-y-3">
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" strokeWidth={1.75}/>
              <Input data-testid="reset-password-input" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" className="h-11 pl-9 rounded-md border-slate-300"/>
            </div>
            {err && <div className="text-xs text-red-600 border border-red-200 bg-red-50 rounded-md p-2">{err}</div>}
            <Button data-testid="reset-submit" type="submit" disabled={busy || !token} className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white rounded-md">
              {busy ? "Updating…" : "Update password"}
            </Button>
            <div className="text-xs text-center pt-2">
              <Link to="/login" className="text-slate-600 hover:text-blue-700">Back to sign in</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
